/* eslint-disable */
import { CropPortrait } from '@material-ui/icons';
import { React, Fragment, Component } from 'react';
import Button from '@material-ui/core/Button';
// import Typography from '@material-ui/Typography';
// import Breadcrumbs from '@material-ui/Breadcrumbs';
// import Link from '@material-ui/Link';

import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";

// function handleClick(event: React.MouseEvent<HTMLDivElement, MouseEvent>) {
//   event.preventDefault();
//   console.info('You clicked a breadcrumb.');
// }
import moment from 'moment';

import DataTable from 'react-data-table-component';
import Select from 'react-select'

import Spinner from 'components/Spinner.js';

const columns = [
  {
    name: 'Site',
    selector: row => row.locncode,
    sortable: true,
  },
  {
    name: 'Role',
    selector: row => row.role,
    sortable: true,
  },
];

export default class RoleList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showTable: false,
      showSpinner: false,
      showSelect: false,
      site: null,
      role: null,
      roleName: null,
      sites: [],
      roles: [],
      data: []
    };
  }

  componentDidMount() {
    // this.state.socket.on('login', user => this.setState({ user, waitingForAuth: false }));
    // this.state.socket.on('error', err => this.setState({ user: null, waitingForAuth: false }));
    this.loadUserRoles();
    this.loadSites();
    this.loadRoles();
  }

  loadUserRoles = () => {
    this.setState({
      showTable: false,
    });

    var $this = this;
    fetch('/api/shared/users/roles/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: JSON.stringify({ user_Id: $this.props.user_id })
    })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        if (data.status.success) {
          $this.setState({
            data: data.data.roles,
            showSpinner: false,
            showTable: true
          });
        }
        else {
          $this.setState({
            showSpinner: false
          });
          alert('There was an error. Please try again later.')
        }
      }).catch(() => {
        $this.setState({
          showSpinner: false
        });
        alert('There was an error. Please try again later.')
      });
  }

  loadSites = () => {
    var $this = this;
    fetch('/api/shared/sitesOnly/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: JSON.stringify({})
    })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        if (data.status.success) {
          $this.setState({
            sites: data.data.sites,
            // showSpinner: false,
            // showTable: true
          });
        }
        else {
          $this.setState({
            showSpinner: false
          });
          alert('There was an error. Please try again later.')
        }
      }).catch(() => {
        $this.setState({
          showSpinner: false
        });
        alert('There was an error. Please try again later.')
      });
  }

  loadRoles = () => {
    var $this = this;
    fetch('/api/shared/roles/list', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: JSON.stringify({})
    })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        if (data.status.success) {
          $this.setState({
            roles: data.data.roles,
            // showSpinner: false,
            // showTable: true
          });
        }
        else {
          $this.setState({
            showSpinner: false
          });
          alert('There was an error. Please try again later.')
        }
      }).catch(() => {
        $this.setState({
          showSpinner: false
        });
        alert('There was an error. Please try again later.')
      });
  }

  handleRowClick = (row) => {
    if (confirm(`Remove role ${row.role} from site ${row.locncode}?`)) {
      var $this = this;
      fetch('/api/shared/users/roles/remove', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
          // 'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: JSON.stringify({
          "userId": $this.props.user_id,
          "locncode": row.locncode,
          "roleId": row.role_id
      })
      })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        if (data.status.success) {
          this.loadUserRoles();
        }
        else {
          $this.setState({
            showSpinner: false
          });
          alert('There was an error. Please try again later.')
        }
      }).catch(() => {
        $this.setState({
          showSpinner: false
        });
        alert('There was an error. Please try again later.')
      });
    }
  }

  handleRoleAdd = () => {
    if (confirm(`Add role ${this.state.role.label} to site ${this.state.site.label}?`)) {
      var $this = this;
      fetch('/api/shared/users/roles/add', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
          // 'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: JSON.stringify({
          "userId": $this.props.user_id,
          "locncode": $this.state.site.value,
          "roleId": $this.state.role.value
      })
      })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        if (data.status.success) {
          this.loadUserRoles();
        }
        else {
          $this.setState({
            showSpinner: false
          });
          alert('There was an error. Please try again later.')
        }
      }).catch(() => {
        $this.setState({
          showSpinner: false
        });
        alert('There was an error. Please try again later.')
      });
    }
  }
  
  handleRoleAddAll = (add) => () => {
    if (confirm(`${add ? 'Add' : 'Remove'} role ${this.state.role.label} ${add ? 'to' : 'from'} sites?`)) {
      var $this = this;
      fetch(`/api/shared/users/roles/${add ? 'addall' : 'removeall'}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
          // 'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: JSON.stringify({
          "userId": $this.props.user_id,
          "roleId": $this.state.role.value
      })
      })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        if (data.status.success) {
          alert(`Role ${$this.state.role.label} ${add ? 'added to' : 'removed from'} ${data.data.rowsChanged} sites.`);
          this.loadUserRoles();
        }
        else {
          $this.setState({
            showSpinner: false
          });
          alert('There was an error. Please try again later.')
        }
      }).catch(() => {
        $this.setState({
          showSpinner: false
        });
        alert('There was an error. Please try again later.')
      });
    }
  }

  handleSiteChange = (site) => {
    this.setState({ site });
  }

  handleRoleChange = (role) => {
    this.setState({ role });
  }

  render ()
  {
    var $this = this;
    return (
      <Fragment>
        { this.state.showSpinner ?
          <Spinner/> 
          : "" 
        }
        { this.state.sites.length > 0 && this.state.roles.length > 0 ?
        <div>
        <GridContainer>
          <GridItem xs={12} sm={12} md={1}>
              Role:
            </GridItem>
            <GridItem xs={12} sm={12} md={3}>
              <Select name="role" //defaultValue={{label:this.state.site, value:this.site}}
                onChange={this.handleRoleChange}
                options ={this.state.roles.map(e => 
                  { return {
                    value: e.id,
                    label: e.name
                  };}
                ) }
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={2}>
              <Button variant="contained" color="primary" onClick={this.handleRoleAddAll(true)} 
                disabled={this.state.role == null} title={`Add role ${this.state.role ? this.state.role.label : ''} to all sites`}>
                  Add All</Button>&nbsp;&nbsp;
              <Button variant="contained" color="primary" onClick={this.handleRoleAddAll(false)} 
                disabled={this.state.role == null} title={`Remove role ${this.state.role ? this.state.role.label : ''} from all sites`}>
                  Remove All</Button>
            </GridItem>
            <GridItem xs={12} sm={12} md={1}>
              Site:
            </GridItem>
            <GridItem xs={12} sm={12} md={3}>
              <Select name="site" //defaultValue={{label:this.state.site, value:this.site}}
                onChange={this.handleSiteChange}
                options ={this.state.sites.map(e => 
                  { return {
                    value: e.locncode,
                    label: e.locncode + ' (' + e.locndscr + ')'
                  };}
                ) }
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={2}>
              { this.state.site != null && this.state.role != null 
              ? <Button variant="contained" color="primary" onClick={this.handleRoleAdd}>Add Role</Button>
              : <Button variant="contained" color="primary" disabled >Add Role</Button>
              }
              
            </GridItem>
          </GridContainer><br/>
        </div>
        : <Spinner/> }
        { this.state.showTable ?
        <DataTable
              columns={columns}
              data={this.state.data}
              keyField='id'
              onRowClicked={r => this.handleRowClick(r)}
              striped
              highlightOnHover
              pointerOnHover
              dense
              pagination
          />
          : <Spinner/>
        }
      </Fragment>
    );
  }
}
